module.exports = __webpack_public_path__ + "img/1.b2c78bd8.gif";